import getEnv from '@ali/arise-h5-utils-env';
var LANS = {
  en: 'Network error, please try again later',
  id: 'Kesalahan jaringan, coba lagi nanti',
  ms: 'Ralat rangkaian, sila cuba lagi kemudian',
  my: 'ကွန်ယက်ကိုအမှား, နောက်မှာထပ်ကြိုးစားကြည့်ပါ',
  th: 'ข้อผิดพลาดของเครือข่ายโปรดลองอีกครั้งในภายหลัง',
  vi: 'Lỗi mạng, vui lòng thử lại sau',
  bn: 'নেটওয়ার্ক ত্রুটি, দয়া করে পরে আবার চেষ্টা করুন',
  si: 'ජාල දෝෂය, නැවත උත්සාහ කරන්න',
  ne: 'सञ्जाल त्रुटि, कृपया पछि फेरि प्रयास गर्नुहोस्',
  ur: 'نیٹ ورک کی غلطی، براہ کرم بعد میں دوبارہ کوشش کریں'
};
function getI18nErrorText() {
  var _getEnv = getEnv(),
    _getEnv$language = _getEnv.language,
    language = _getEnv$language === void 0 ? 'EN' : _getEnv$language;
  return LANS[language.toLowerCase()] || LANS.en;
}
export default function formatMtopRet(ret) {
  var retMsg = ret && ret.length && ret[0].split('::');
  if (ret[0].indexOf('FAIL_SYS') !== -1 || ret[0].indexOf('SYSTEM_ERROR') !== -1 || ret[0].indexOf('UNKNOWN_FAIL_CODE') !== -1 || ret[0].indexOf('TIMEOUT') !== -1) {
    return {
      key: retMsg[0],
      displayMessage: getI18nErrorText()
    };
  }
  if (retMsg && retMsg[1]) {
    return {
      key: retMsg[0],
      displayMessage: retMsg[1]
    };
  }
  return {
    key: ret[0],
    displayMessage: getI18nErrorText()
  };
}